import moment from 'moment';

import { ReportTypeID } from '~/src/dash/apiV2/reporting/reportTypes';

export interface IReportDataRow {
  ab_testing_config_id?: number;
  ab_testing_config_name?: string;
  ab_testing_test_id?: number;
  ab_testing_test_name?: string;
  active_bidder_tier?: number;
  active_margin?: number;
  ad_block_count?: number;
  ad_block_rate?: number;
  ad_break_position?: number;
  ad_complete?: number;
  ad_duration?: number;
  ad_filled?: number;
  ad_first_quartile?: number;
  ad_impression?: number;
  ad_impression_ss?: number;
  ad_mid_point?: number;
  ad_render_faileds?: number;
  ad_size?: string;
  ad_source_id?: number;
  ad_third_quartile?: number;
  ad_unit_id?: string;
  ad_unit_path?: string;
  ad_vod_win?: number;
  adblockpct?: number;
  adomain?: string;
  adsource_id?: number;
  adsourcename?: string;
  adunit_position?: string;
  adv_entity_id?: string;
  advertiser_id?: string;
  advertiser_name?: string;
  advertiser_rule_cpm_rev?: number;
  advertiser_rule_cpms_rev?: number;
  advertiser_rule_pod_lift?: number;
  agency_name?: string;
  an_id?: string;
  apk_build?: string;
  app_bundle_id?: string;
  app_name?: string;
  applied_contextual_segment_ids?: string;
  applied_contextual_segment_names?: string;
  applied_contextual_segment_partners?: string;
  aps_bids_submitted?: number;
  aps_key?: string;
  auction_clear_rate?: number;
  auction_ends?: number;
  auction_latency?: number;
  audience_id?: string;
  avg_ad_complete_per_session?: number;
  avg_ad_filled_per_session?: number;
  avg_ad_first_quartile_per_session?: number;
  avg_ad_impression_per_session?: number;
  avg_ad_mid_point_per_session?: number;
  avg_ad_third_quartile_per_session?: number;
  avg_bid?: number;
  avg_duration?: number;
  avg_imp_ecpm?: number;
  avg_imp_gross_ecpm?: number;
  avg_pod_complete_per_session?: number;
  avg_pod_filled_per_session?: number;
  avg_pod_request_per_session?: number;
  avg_stream_ad_filled_latency?: number;
  avg_stream_chunklist_response_latency?: number;
  avg_stream_error_per_session?: number;
  avg_stream_response_latency?: number;
  avg_stream_start_per_session?: number;
  avg_watch_time_per_session?: number;
  avg_watch_time_per_viewer?: number;
  avg_winning_bid?: number;
  bid_adjustments?: number;
  bid_auctions?: number;
  bid_deal_id?: string;
  bid_density?: string;
  bid_dones?: number;
  bid_error_code?: string;
  bid_error_rate?: number;
  bid_errors?: number;
  bid_floor?: number;
  bid_loss_rate_price?: number;
  bid_loss_rate_tier?: number;
  bid_losts?: number;
  bid_none?: number;
  bid_rejections?: number;
  bid_request_rate?: number;
  bid_requests?: number;
  bid_requests_rejected?: number;
  bid_response_deal_id?: string;
  bid_response_rate?: number;
  bid_responses?: number;
  bid_responses_rejected?: number;
  bid_saver_bid_won?: number;
  bid_saver_impressions?: number;
  bid_saver_pod_lift?: number;
  bid_saver_true_lift?: number;
  bid_scheduling_issues?: number;
  bid_timeouts?: number;
  bid_timeouts_rate?: number;
  bid_won_reject_reason?: string;
  bid_wons?: number;
  bid_wons_rejected?: number;
  bidder_group?: string;
  bidder_id?: string;
  bidder_label_id?: number;
  bidder_label_name?: string;
  bidder_parameters?: string;
  bidder_priority?: string;
  bidder_subtier?: number;
  bidder_tier?: number;
  bidder_type?: string;
  bidder_type_plain?: string;
  biddername?: string;
  bounce_rate?: number;
  brand_safety_rule_id?: number;
  brand_safety_tracker_name?: string;
  brand_safety_tracker_type?: string;
  buyers_latency?: number;
  campaign_complete?: number;
  campaign_filled?: number;
  campaign_id?: string;
  campaign_impression?: number;
  campaign_inventory_request?: number;
  campaign_no_fill?: number;
  campaign_quartile1?: number;
  campaign_quartile2?: number;
  campaign_quartile3?: number;
  campaign_request?: number;
  campaign_start?: number;
  campaignname?: string;
  category?: string;
  channel_group?: string;
  channel_label_id?: number;
  channel_label_name?: string;
  city?: string;
  clear_rate_by_pod_duration?: number;
  clicks?: number;
  complete?: number;
  completion_rate?: number;
  content_cat?: string;
  content_channel?: string;
  content_context?: string;
  content_dist_id?: string;
  content_dist_name?: string;
  content_episode?: number;
  content_genre?: string;
  content_id?: string;
  content_keywords?: string;
  content_language?: string;
  content_length?: number;
  content_network?: string;
  content_prodqual?: string;
  content_producer_id?: string;
  content_producer_name?: string;
  content_rating?: string;
  content_season?: string;
  content_series?: string;
  content_title?: string;
  coppa?: string;
  cost_to_publisher?: number;
  country?: string;
  country_group_id?: number;
  country_group_name?: string;
  cpm?: number;
  cpm_per_second?: number;
  cpm_rev?: number;
  cpms_rev?: number;
  creation_latency?: number;
  creative_errors?: number;
  creative_id?: number;
  creative_name?: string;
  creative_tag_requests?: number;
  creative_tag_responses?: number;
  cst_ad_filled?: number;
  cst_ad_impression?: number;
  cst_render_rate?: number;
  currency_type?: string;
  custom1?: string;
  custom11?: string;
  custom12?: string;
  custom13?: string;
  custom14?: string;
  custom15?: string;
  custom16?: string;
  custom17?: string;
  custom18?: string;
  custom1number?: string;
  custom2?: string;
  custom3?: string;
  custom4?: string;
  custom5?: string;
  custom6?: string;
  custom7?: string;
  custom8?: string;
  custom9?: string;
  custom_targeting?: string;
  data_provider?: string;
  data_type?: string;
  date?: string;
  datelabel?: string;
  deal_id?: string;
  deal_name?: string;
  dedup_bypass?: false;
  delivered_ads?: number;
  delivered_pod_duration?: number;
  demand_path?: string;
  demand_side_platform_id?: number;
  demandtype?: string;
  destination_error_code?: number;
  destination_id?: number;
  destination_impressions?: number;
  destination_name?: string;
  destination_no_fills?: number;
  destination_request_errors?: number;
  destination_request_latency?: number;
  destination_requests?: number;
  destination_responses?: number;
  destination_site_id?: number;
  destination_site_name?: string;
  destination_timeouts?: number;
  destination_type?: number;
  device?: string;
  device_geo_region?: string;
  device_make?: string;
  device_model?: string;
  device_os?: string;
  device_subtype?: string;
  deviceenv?: string;
  devicetype?: string;
  did_bucket?: number;
  dma?: string;
  do_not_track?: string;
  dsp_name?: string;
  duration?: number;
  duration_exceeded?: number;
  duration_remaining_after_partner_primary?: number;
  elea_ai_bid_errors?: number;
  elea_ai_bid_errors_different_adomain?: number;
  elea_ai_bid_errors_different_adomain_rate?: number;
  elea_ai_bid_losts?: number;
  elea_ai_bid_losts_different_adomain?: number;
  elea_ai_bid_losts_different_adomain_rate?: number;
  elea_ai_bid_responses?: number;
  elea_ai_bid_responses_different_adomain?: number;
  elea_ai_bid_responses_different_adomain_rate?: number;
  elea_ai_bid_won_rate?: number;
  elea_ai_bid_wons?: number;
  elea_ai_bid_wons_different_adomain?: number;
  elea_ai_bid_wons_different_adomain_rate?: number;
  elea_ai_detected_language?: string;
  elea_ai_detected_language_blocked_bids?: number;
  elea_ai_enriched_adomain?: string;
  elea_ai_impression_rate?: number;
  elea_ai_impressions?: number;
  elea_ai_impressions_different_adomain?: number;
  elea_ai_impressions_different_adomain_rate?: number;
  elea_ai_mediafile?: string;
  elea_ai_num_total_adomains_bid_errors?: number;
  elea_ai_num_total_adomains_bid_losts?: number;
  elea_ai_num_total_adomains_bid_responses?: number;
  elea_ai_num_total_adomains_bid_wons?: number;
  elea_ai_num_total_adomains_impressions?: number;
  elea_ai_num_total_detected_languages_bid_errors?: number;
  elea_ai_num_total_detected_languages_bid_losts?: number;
  elea_ai_num_total_detected_languages_bid_responses?: number;
  elea_ai_num_total_detected_languages_bid_wons?: number;
  elea_ai_num_total_detected_languages_impressions?: number;
  elea_ai_num_total_mediafiles_bid_errors?: number;
  elea_ai_num_total_mediafiles_bid_losts?: number;
  elea_ai_num_total_mediafiles_bid_responses?: number;
  elea_ai_num_total_mediafiles_bid_wons?: number;
  elea_ai_num_total_mediafiles_impressions?: number;
  elea_ai_num_unique_adomains_bid_errors?: number;
  elea_ai_num_unique_adomains_bid_losts?: number;
  elea_ai_num_unique_adomains_bid_responses?: number;
  elea_ai_num_unique_adomains_bid_wons?: number;
  elea_ai_num_unique_adomains_impressions?: number;
  elea_ai_num_unique_detected_languages_bid_errors?: number;
  elea_ai_num_unique_detected_languages_bid_losts?: number;
  elea_ai_num_unique_detected_languages_bid_responses?: number;
  elea_ai_num_unique_detected_languages_bid_wons?: number;
  elea_ai_num_unique_detected_languages_impressions?: number;
  elea_ai_num_unique_mediafiles_bid_errors?: number;
  elea_ai_num_unique_mediafiles_bid_losts?: number;
  elea_ai_num_unique_mediafiles_bid_responses?: number;
  elea_ai_num_unique_mediafiles_bid_wons?: number;
  elea_ai_num_unique_mediafiles_impressions?: number;
  elea_ai_original_adomain?: string;
  eligible_ads?: number;
  endpoint_error_code?: string;
  endpoint_latency?: number;
  endpoint_request_ecpm?: number;
  endpoint_requests?: number;
  endpoint_responses?: number;
  event_auction_inits?: number;
  event_bidder_impression?: number;
  event_endpoint_errors?: number;
  event_endpoint_request?: number;
  event_pod_compare?: number;
  event_pod_compare_with_advertiser_rules?: number;
  event_pod_compare_without_advertiser_rules?: number;
  event_start?: number;
  failed_ad_rate?: number;
  failed_imps?: number;
  fill_rate_by_demand_source?: number;
  filled_adomains?: number;
  filled_ads?: number;
  filled_pod_duration?: number;
  filled_vmap_duration?: number;
  fillrate?: number;
  flight_date_checkpoint_id?: string;
  flight_date_checkpoint_name?: string;
  fw_render_rate?: number;
  fw_section_id?: string;
  fw_section_id_v2?: string;
  fw_section_name?: string;
  fw_win_rate?: number;
  gdpr?: string;
  gdpr_consent?: string;
  gpp_consent_status?: string;
  givt_ads?: number;
  givt_rate?: number;
  global_mediafile_id?: number;
  global_timeout?: number;
  global_vast_id?: number;
  gross_revenue?: number;
  grouplabel?: string;
  has_advertiser_rule_responses?: boolean;
  hls_reject?: number;
  ias_contextual_info?: string;
  imp_cpm?: number;
  impressed_bidder_type?: string;
  impression_ad_duration?: number;
  impression_ad_duration_unpaid?: number;
  impression_rendered?: number;
  impressions?: number;
  impressions_unpaid?: number;
  inbound_deal_id?: string;
  inbound_wseat?: string;
  inventory_route_condition?: number;
  inventory_route_endpoint_latency?: number;
  inventory_route_error_code?: number;
  inventory_route_errors?: number;
  inventory_route_id?: number;
  inventory_route_name?: string;
  inventory_route_no_fills?: number;
  inventory_route_requests?: number;
  inventory_route_response_destination_id?: number;
  inventory_route_responses?: number;
  ip_type?: string;
  iris_context?: string;
  iris_contextual_info?: string;
  iris_id?: string;
  is_bid_saver?: false;
  is_fallback_response?: false;
  is_multi_bid?: false;
  is_partial_ad_break?: string;
  is_philo_fallback_auction?: boolean;
  is_podded_request?: false;
  ivt_ads?: number;
  ivt_fail_rate?: number;
  ivt_rate?: number;
  language?: string;
  line_item_alias?: string;
  line_item_count?: number;
  line_item_id?: string;
  line_item_name?: string;
  line_item_status?: string;
  liveramp_cpm?: number;
  liveramp_revenue?: number;
  liveramp_segment_ids?: string;
  livestream?: string;
  lr_1p_matching_fee?: string;
  lr_3p_matching_fee?: string;
  lr_dm_data_fee?: string;
  lr_dm_providers?: string;
  lr_dm_seg_ids?: string;
  market_type?: string;
  max_available_pod_duration_by_tier?: number;
  measured_ads?: number;
  measured_rate?: number;
  media_cost?: number;
  media_file?: string;
  media_type?: string;
  media_type_id?: string;
  mediafile_count?: string;
  native_companion_click?: number;
  native_creative_view?: number;
  native_video_click?: number;
  needs_creative?: string;
  net_unit_cost?: number;
  network_channel_id?: number;
  network_channel_name?: string;
  network_channel_site_id?: number;
  network_channel_site_name?: string;
  network_id?: number;
  network_name?: string;
  no_bid_saver_rev?: number;
  no_fill_reason?: string;
  non_cst_ad_filled?: number;
  non_cst_ad_impression?: number;
  non_cst_render_rate?: number;
  non_viewable_imp_rate?: number;
  non_viewable_impression?: number;
  num_bidder_types?: number;
  num_of_users?: number;
  num_sites?: number;
  number_of_ads_requested?: number;
  number_of_blocks?: number;
  number_of_winners?: number;
  onscreen_complete?: number;
  onscreen_completion_rate?: number;
  operating_system?: string;
  order_alias?: string;
  order_id?: string;
  order_name?: string;
  ortb_site_name?: string;
  ortb_wins?: number;
  outbound_deal_id?: string;
  page_load_time?: number;
  pageviews?: number;
  paid_filled_pod_duration?: number;
  paid_pod_clear_rate?: number;
  partner_cpm?: number;
  partner_declared_sov?: number;
  partner_revenue?: number;
  pass_rate?: number;
  passed_imps?: number;
  philo_fallback?: string;
  placement_id?: string;
  pod_clear_rate?: number;
  pod_compare_pod_duration?: number;
  pod_compare_revenue?: number;
  pod_compare_type?: number;
  pod_complete?: number;
  pod_complete_rate?: number;
  pod_duration?: number;
  pod_duration_backfilled?: number;
  pod_duration_owned_by_non_sov_bidder?: number;
  pod_duration_owned_by_sov_bidder?: number;
  pod_fill_rate?: number;
  pod_filled?: number;
  pod_level_sov_type?: number;
  pod_request?: number;
  pod_start?: number;
  pod_start_ss?: number;
  postbid_errors?: number;
  prebid_errors?: number;
  preset_aggregate_last_seven_days?: number;
  preset_aggregate_last_thirty_days?: number;
  preset_aggregate_yesterday?: number;
  pub_entity_id?: string;
  publica_bidder_id?: string;
  publica_channel_id?: string;
  publica_cpm?: number;
  publica_deal_id?: string;
  publica_revenue?: number;
  publisher_cpm?: number;
  publisher_id?: string;
  publisher_margin?: number;
  publisher_name?: string;
  publisher_revenue?: number;
  quartile1?: number;
  quartile1_rate?: number;
  quartile2?: number;
  quartile2_rate?: number;
  quartile3?: number;
  quartile3_rate?: number;
  rawQuery?: string;
  recognition_result_enriched_language_input?: string;
  recovery_active?: number;
  render_rate?: number;
  render_rate_by_pod_duration?: number;
  requested_pod_duration?: number;
  requested_vmap_duration?: number;
  requests?: number;
  revenue?: number;
  review_status?: number;
  roku_ad_keys?: string;
  salesperson_name?: string;
  samsung_model?: string;
  segmentids?: string;
  segmentname?: string;
  sessions_per_user?: number;
  set_targetings?: number;
  share_of_voice?: number;
  share_type?: string;
  shared_filled_vmap_duration?: number;
  shared_requested_vmap_duration?: number;
  site_page?: string;
  siteid?: string;
  sitename?: string;
  sivt_ads?: number;
  sivt_rate?: number;
  skip?: number;
  skip_offset?: number;
  slot_number?: number;
  sov_inventory_type?: string;
  spotx_endpoint?: number;
  spotx_param_channel_id?: number;
  start_date?: string;
  state?: string;
  stream_ad_chunklist_response?: number;
  stream_ads_fetch_timeout?: number;
  stream_chunklist_fetch?: number;
  stream_chunklist_timeout?: number;
  stream_error?: number;
  stream_error_code?: string;
  stream_format_type?: string;
  stream_playlist_timeout?: number;
  stream_start?: number;
  synthetic_id?: number;
  targeting_device?: string;
  timestamp?: string;
  timezone?: string;
  topcountries?: string;
  total_count?: number;
  total_delivered_pod_duration?: number;
  total_filled_pod_duration?: number;
  total_imp_ecpm?: number;
  total_paid_filled_pod_duration?: number;
  total_requested_pod_duration?: number;
  total_stream_ad_filled_latency?: number;
  tracked_ads?: number;
  traffic_type?: string;
  trafficker_name?: string;
  ttd_losses?: number;
  ttd_losses_comp_sep_other?: number;
  ttd_losses_comp_sep_self?: number;
  ttd_losses_do_not_air?: number;
  ttd_losses_other?: number;
  ttd_losses_price?: number;
  ttd_losses_price_or_tier?: number;
  ttd_losses_tier?: number;
  ttd_responses?: number;
  ttd_spend?: number;
  ttd_wins?: number;
  unique_endpoint_request?: number;
  unique_users?: number;
  unique_viewers?: number;
  uniquesessions?: number;
  unmeasured_imps?: number;
  unmeasured_imps_rate?: number;
  url_fail_rate?: number;
  us_privacy?: string;
  username?: string;
  valid_video_ads?: number;
  valid_viewable_video_ads?: number;
  vast_error_code?: string;
  vast_errors?: number;
  vast_tracker_endpoint_domain?: string;
  vast_xml_impressions?: number;
  venue_id?: string;
  viewability_rate?: number;
  viewable_complete?: number;
  viewable_complete_rate?: number;
  viewable_impression?: number;
  viewable_quartile1?: number;
  viewable_quartile1_rate?: number;
  viewable_quartile2?: number;
  viewable_quartile2_rate?: number;
  viewable_quartile3?: number;
  viewable_quartile3_rate?: number;
  views_per_session?: number;
  vmap_latency?: number;
  vmap_requests?: number;
  vmap_responses?: number;
  vpaid_complete?: number;
  vpaid_errors?: number;
  vpaid_impressions?: number;
  vpaid_quartile1?: number;
  vpaid_quartile2?: number;
  vpaid_quartile3?: number;
  vpaid_start?: number;
  wait_latency?: number;
  win_rate?: number;
  zip?: string;
  // Smart Floors
  control_bid_requests?: number;
  optimized_bid_requests?: number;
  low_bid_requests?: number;
  high_bid_requests?: number;
  control_bid_responses?: number;
  optimized_bid_responses?: number;
  low_bid_responses?: number;
  high_bid_responses?: number;
  control_bid_wons?: number;
  optimized_bid_wons?: number;
  low_bid_wons?: number;
  high_bid_wons?: number;
  control_avg_winning_bid?: number;
  optimized_avg_winning_bid?: number;
  low_avg_winning_bid?: number;
  high_avg_winning_bid?: number;
  control_bid_floor?: number;
  optimized_bid_floor?: number;
  low_bid_floor?: number;
  high_bid_floor?: number;
  // Traffic Shaping
  traffic_shaping_control_bid_requests?: number;
  traffic_shaping_optimized_bid_requests?: number;
  traffic_shaping_optimized_bid_responses?: number;
  traffic_shaping_control_bid_responses?: number;
  traffic_shaping_optimized_bid_response_rate?: number;
  traffic_shaping_control_bid_response_rate?: number;
  traffic_shaping_optimized_bid_impressions?: number;
  traffic_shaping_control_bid_impressions?: number;
  traffic_shaping_optimized_revenue?: number;
  traffic_shaping_control_revenue?: number;
  traffic_shaping_bid_request_difference?: number;
  traffic_shaping_bid_response_difference?: number;
  traffic_shaping_bid_impressions_difference?: number;
  traffic_shaping_bid_response_rate_difference?: number;
  traffic_shaping_revenue_difference?: number;
  requests_over_revenue?: number;
}

// all the formatting fucntions below are copied over from the current reporting with minimal refactoring
// TODO: see if we can collapse and make these simpler
export interface IFormatFunction {
  name: string;
  regex: RegExp;
  formattingFunction: (
    input: any,
    reportTypeID?: number,
    exchangeRate?: number,
    currencySymbol?: string,
  ) => any;
}

// formatSyntheticID transforms a number into "DeviceID" or "SyntheticID"
export const formatSyntheticID = (data: any): any => {
  switch (data) {
    case data === 0:
      return 'Device ID';
    case data === 1:
      return 'Synthetic ID';
    case data === 2:
      return 'Unkown';
    default:
      return data;
  }
};

// formatSpotxEndpoint transforms a number into a Spotx Endpoint
export const formatSpotxEndpoint = (data: number) => {
  switch (data) {
    case 1:
      return 'US West';
    case 2:
      return 'US East';
    case 3:
      return 'EMEA';
    case 4:
      return 'APAC';
    default:
      return 'Other / Non-Spotx Endpoint';
  }
};

// formatSpotxChannelID transforms a number into '' if this number is 0
export const formatSpotxChannelID = (data: any): any => (data === 0 ? '' : data);

// formatDuration transforms a number into a duration in seconds
// Example: 93 -> 93.00s
export const formatDuration = (data: any): any =>
  typeof data === 'number' ? (Math.round(data * 100) / 100).toFixed(2) + 's' : data;

// formatLatency transforms a number into a duration in ms
// Example: 76 -> 76.00ms
export const formatLatency = (data: any): any =>
  typeof data === 'number' ? (Math.round(data * 100) / 100).toFixed(2) + 'ms' : data;

// formatCurrency transforms a number or a string into a USD currency
// Example: 32 -> $32.00
export const formatCurrency = (
  data: any,
  _reportTypeID: number,
  exchangeRate = 1,
  currencySymbol = '$',
): any => {
  // return if data is neither string or number
  if (typeof data !== 'string' && typeof data !== 'number') return '';

  // convert data to a string number with 2 decimals, ex: 43.201 -> '43.20'
  const parsedNumStr =
    typeof data === 'string'
      ? (parseFloat(data) * exchangeRate).toFixed(2)
      : (Math.round(data * exchangeRate * 100) / 100).toFixed(2);

  // formatHugeNumber on the whole number, then joins it back with the decimal and currencySymbol
  const [whole, decimals] = parsedNumStr.split('.');
  return currencySymbol + formatHugeNumber(whole) + '.' + decimals;
};

// formatRate transforms a number into a percentage
// Example: 0.43 -> 43%
export const formatRate = (data: any, reportTypeID: number): any => {
  if (typeof data !== 'number') return data;
  if (
    [
      ReportTypeID.AuctionFillRateReport,
      ReportTypeID.IASFirstPartyVASTTrackingReport,
      ReportTypeID.IASThirdPartyVASTTrackingReport,
      ReportTypeID.TrafficShapingReport,
    ].includes(reportTypeID)
  ) {
    return (data * 100).toFixed(2) + '%';
  }

  if (
    [ReportTypeID.EleaAIEnrichmentReport, ReportTypeID.EleaAIScanAllReport].includes(reportTypeID)
  ) {
    // Elea AI Reports
    return (data * 100).toFixed(1) + '%';
  }

  return Math.round(data * 100) + '%';
};

// formatRate non percentage
// Example: 0.4312 -> 43.12
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const formatRateNonPercentage = (data: any): any => {
  if (typeof data !== 'number') return data;
  return (data * 100).toFixed(2);
};

// formatHugeNumber transforms a number to a comma separated number. Work also with number in strings
// Examples: 123456789 -> 123,456,789 || "I ate 47312 apples" -> "I ate 47,312 apples"
export const formatHugeNumber = (data: any): any => {
  // return if data is not a string or number
  if (typeof data !== 'string' && typeof data !== 'number') return data;

  // Number too small to need coma separation
  if (typeof data === 'number' && data < 1000 && data > -1000) return data;

  // return if we cant parse the number
  data = String(data);
  if (isNaN(parseInt(data, 10)) || isNaN(parseFloat(data))) return data;

  // Formatting large number
  let counter = 0;
  for (let i = data.length - 1; i >= 0; i--) {
    if (data[i] >= '0' && data[i] <= '9') {
      if (counter > 0 && counter % 3 === 0) {
        data = data.slice(0, i + 1) + ',' + data.slice(i + 1);
      }
      counter += 1;
    } else {
      counter = 0;
    }
  }

  return data;
};

// formatDate transforms a sql-formatted date into a hunan one
// Example: 2020-03-12 -> March 12th 2020
export const formatDate = (data: any): any => {
  // return if data is not string
  if (typeof data !== 'string') return data;

  if (!data.includes('T')) data = data + 'T00:00:00+00:00';

  const date = new Date(data);
  // Only the month
  if (data.split('-').length === 2) return moment(date).tz('UTC').format('MMMM YYYY');

  // Full date
  return moment(date).tz('UTC').format('MMMM Do YYYY');
};

// formatMonth transforms a sql-fromatted date into a hunan one (without days)
// Example: 2020-03-12 -> March 2020
export const formatMonth = (data: any): any => {
  // return if data is not string
  if (typeof data !== 'string') return data;

  if (!data.includes('T')) data = data + 'T00:00:00+00:00';
  const date = new Date(data);
  return moment(date).tz('UTC').format('MMMM YYYY');
};

// formatHour transforms a sql-formatted date into a hunan one (without days)
// Example: 2020-03-12T00:00:00 -> March 12th 2020  15h00
export const formatHour = (data: any): any => {
  // return if data is not string
  if (typeof data !== 'string') return data;
  if (!data.includes('T')) data = data + 'T00:00:00+00:00';
  const date = new Date(data);
  if (data.split('-').length === 2) {
    // Only the month
    return moment(date).tz('UTC').format('MMMM YYYY');
  }
  // Full date
  return moment(date).tz('UTC').format('MMMM Do YYYY HH:mm');
};

// formatAdBreakPosition
export const formatAdBreakPosition = (data: number): string => {
  switch (data) {
    case 0:
      return 'No Position Specified';
    case 1:
      return 'Pre-Roll';
    case 2:
      return 'Mid-Roll';
    case 3:
      return 'Post-Roll';
    default:
      return 'Unknown Position';
  }
};

// formatIsPartialAdBreak
export const formatIsPartialAdBreak = (data: boolean): string =>
  data ? 'Partial Ad Break' : 'Full Ad Break';

// formatBoolean
export const formatBoolean = (data: boolean): string => (data ? 'TRUE' : 'FALSE');

// formatMediaTypeID
export const formatMediaTypeID = (data: string): string => {
  switch (data) {
    case '111':
      return 'Desktop Web Display';
    case '112':
      return 'Desktop Web Video';
    case '121':
      return 'Mobile Web Display';
    case '122':
      return 'Mobile Web Video';
    case '131':
      return 'Tablet Web Display';
    case '132':
      return 'Table Web Video';
    case '221':
      return 'Mobile In-App Display';
    case '222':
      return 'Mobile In-App Video';
    case '231':
      return 'Tablet In-App Display';
    case '252':
      return 'CTV In App Video';
    case '152':
      return 'Browser CTV Video';
    default:
      return '';
  }
};

// regexes that inform how to format data of a column
export const formatFunctions: IFormatFunction[] = [
  {
    regex: new RegExp('spotx_endpoint', 'i'),
    formattingFunction: formatSpotxEndpoint,
    name: 'formatSpotxEndpoint',
  },
  {
    regex: new RegExp('spotx_param_channel_id', 'i'),
    formattingFunction: formatSpotxChannelID,
    name: 'formatSpotxChannelID',
  },
  {
    regex: new RegExp('media_type_id', 'i'),
    formattingFunction: formatMediaTypeID,
    name: 'formatMediaTypeID',
  },
  {
    regex: new RegExp(
      '(dedup_bypass|is_bid_saver|has_advertiser_rule_responses|is_multi_bid|is_podded_request|is_fallback_response|has_google_pal_sdk_givn_param)',
      'i',
    ),
    formattingFunction: formatBoolean,
    name: 'formatMediaTypeID',
  },
  {
    regex: new RegExp('synthetic_id', 'i'),
    formattingFunction: formatSyntheticID,
    name: 'formatSyntheticID',
  },
  { regex: new RegExp('rate$|.rate.', 'i'), formattingFunction: formatRate, name: 'formatRate' },
  {
    regex: new RegExp('(revenue.*|cpm.*|cpm$|revenue$|^avg.*bid$|lift|ttd_spend)', 'i'),
    formattingFunction: formatCurrency,
    name: 'formatCurrency',
  },
  { regex: new RegExp('latency$', 'i'), formattingFunction: formatLatency, name: 'formatLatency' },
  {
    regex: new RegExp('.+duration', 'i'),
    formattingFunction: formatDuration,
    name: 'formatDuration',
  },
  // https://regex101.com/r/hVjFbh/2
  {
    regex: new RegExp('^(hour|half_hour).*', 'i'),
    formattingFunction: formatHour,
    name: 'formatHour',
  },
  // https://regex101.com/r/xZJ785/1
  {
    regex: new RegExp('^day.*|start_date', 'i'),
    formattingFunction: formatDate,
    name: 'formatDate',
  },
  // https://regex101.com/r/iNJFfu/1
  {
    regex: new RegExp('^(date|month|year).*', 'i'),
    formattingFunction: formatMonth,
    name: 'formatMonth',
  },
  // https://regex101.com/r/YGObU9/1
  {
    regex: new RegExp(
      '^(?!app_bundle_id|content_id|deal_id|bid_deal_id|inbound_wseat|inbound_deal_id|outbound_deal_id|siteid|bidder_id|biddername|segmentname|zip|start_date|apk_build|samsung_model|destination_site_id|inventory_route_id|destination_id|publisher_id|placement_id|publica_channel_id|publica_bidder_id|line_item_id|advertiser_id|order_id|creative_id|ad_unit_id|ad_size|fw_section_id_v2|venue_id|network_id|network_channel_id|media_file|revenue|campaignname|line_item_alias|order_alias).*',
      'i',
    ),
    formattingFunction: formatHugeNumber,
    name: 'formatHugeNumber',
  },
  {
    regex: new RegExp('ad_break_position', 'i'),
    formattingFunction: formatAdBreakPosition,
    name: 'formatAdBreakPosition',
  },
  {
    regex: new RegExp('is_partial_ad_break', 'i'),
    formattingFunction: formatIsPartialAdBreak,
    name: 'formatIsParialAdBreak',
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formattingFunctionOverride: Record<string, (data: any, reportTypeID: number) => any> =
  {
    traffic_shaping_bid_impressions_difference: formatRate,
    traffic_shaping_bid_request_difference: formatRate,
    traffic_shaping_bid_response_difference: formatRate,
    traffic_shaping_control_bid_response_rate: formatRateNonPercentage,
    traffic_shaping_optimized_bid_response_rate: formatRateNonPercentage,
    traffic_shaping_revenue_difference: formatRate,
    requests_over_revenue: formatHugeNumber,
  };
